import { createFileRoute } from "@tanstack/react-router";

import { parseReportSearch } from "@/features/money";
import { ReportPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/report")({
  validateSearch: strictSearch(parseReportSearch),
  component: Report,
});

function Report() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
